const copyDatesToAllGroups = (btn) => {
    const srcInputs = btn.parentNode.parentNode.querySelectorAll('input');
    const table = document.getElementById('groups-dates-table');
    const firstColInputs = table.querySelectorAll('td:nth-child(2) input');
    const secondColInputs = table.querySelectorAll('td:nth-child(3) input');
    firstColInputs.forEach((input) => {
        input.value = srcInputs[0].value;
    });
    secondColInputs.forEach((input) => {
        input.value = srcInputs[1].value;
    });
}

export {
    copyDatesToAllGroups
};